import { combineReducers } from 'redux'

import locationTypeCategoryReducer from './location-type-category-reducer'
import locationTypeReducer from './location-type-reducer'
import locationTypesAndLocationTypeCategoriesReducer from './location-types-and-location-type-categories-reducer'

export default combineReducers({
  locationTypesAndLocationTypeCategories:
    locationTypesAndLocationTypeCategoriesReducer,
  locationTypeCategory: locationTypeCategoryReducer,
  locationType: locationTypeReducer,
})
